export var DATE_PICKER_CLASS_PREFIX = 'DatePicker';
export var DATE_RANGE_PICKER_CLASS_PREFIX = 'DateRangePicker';
export var DATE_PICKER_MODE_AM = 'am';
export var DATE_PICKER_MODE_PM = 'pm';
export var DATE_PICKER_MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];